import React from 'react';

import { LINK_CLICK_TO_TALK } from '../config.js';

export default function ChatEndedBanner({isDarkMode}) {
  const isDark = !!isDarkMode;
  return (
    <div id="archived-chat-note" className={`archived-chat-note archived-chat-note${isDark ? '-dark' : '-light'}`}>
      <div className={`archived-chat-note-heading ${isDark && 'archived-chat-note-heading-dark'}`}>
        Chat has ended
      </div>
      <div className={`archived-chat-note-text ${isDark && 'archived-chat-note-text-dark'}`}>
        You may contact{' '}
        <a
          className="archived-chat-note-support-link"
          href={LINK_CLICK_TO_TALK}
          target="_blank"
          rel="noopener noreferrer">
          support
        </a>
        {' '}if you need any assistance.
      </div>
    </div>
  );
}
